<template>
  <div class="card-item secondary">
    <h5 class="is-size-5">{{ $t('transactions.debtByDateTitle') }}</h5>
    <div id="modifier-items">
      <div>
        {{ $t('generalWords.Date') }}: <b-datepicker v-model="date" :append-to-body="true" size="is-small" />
      </div>
      <div v-if="$i18n.locale === 'cl'">
        Valor UF: <span v-if="isLoading" class="fas fa-spinner fa-spin" /><div v-else>${{ secondaryCurrencyFactor }}</div>
      </div>
      <div>
        {{ $t('transactions.debtAmount') }}:
        <span v-if="isLoading" class="fas fa-spinner fa-spin" />
        <div v-else>${{ amount }}</div>
      </div>
      <div>
        <b-button
          rounded
          :disabled="!checkUserFeature('element.transaction-approval.button.transaction-modify')"
          size="is-small"
          :class="`is-button-primary ${isLoading ? 'is-loading' : ''}`"
          @click="updateTransaction">
          Modificar {{ $t('generalWords.transaction') }}
        </b-button>
      </div>
    </div>
    <div v-if="!!errorMessage">
      <p class="help is-danger"> {{ errorMessage }} </p>
    </div>
  </div>
</template>
<script>
import { getClientDebt } from '@/application/services/api-clients/clients';
import { formatNumber } from '@/infrastructure/format';
import { updateTransactionDebtDate } from '@/application/services/api-clients/transactions';
import userFeatures from '@/ui/mixins/user-features';

export default {
  mixins: [userFeatures],
  props: ['transaction'],
  data() {
    return {
      date: new Date(),
      cancelGetClientDebt: null,
      isLoading: false,
      amount: '',
      secondaryCurrencyFactor: '',
      errorMessage: ''
    };
  },
  computed: {
    transactionOperationsIds() {
      return this.transaction.selectedPayments.map(x => x.companyOperationId);
    },
    paymentsNumbersMap() {
      const map = {};
      this.transaction.selectedPayments.forEach(x => {
        map[x.companyOperationId] = x.paymentsNumbers;
      });
      return map;
    }
  },
  watch: {
    async date(val) {
      this.errorMessage = '';
      this.secondaryCurrencyFactor = '';
      this.amount = '';
      if (this.isLoading) {
        this.cancelGetClientDebt('cancelled');
      }
      this.isLoading = true;
      try {
        const date = val.toISOString().substring(0, 10);
        const cancelExecutor = cancelFunction => { this.cancelGetClientDebt = cancelFunction; };
        const { debt } = await getClientDebt(this.transaction.clientId, date, cancelExecutor);
        this.isLoading = false;
        if (debt.length === 0) {
          this.errorMessage = 'Cliente no registra deuda en la fecha seleccionada';
          return;
        }
        this.secondaryCurrencyFactor = formatNumber({ number: debt[0].payments[0].secondaryCurrencyFactor });
        const total = debt.reduce((acc, op) => {
          if (!this.transactionOperationsIds.includes(op.companyOperationId)) {
            return acc;
          }
          return acc + op.payments.reduce((accumulator, payment) => {
            if (!this.paymentsNumbersMap[op.companyOperationId].includes(payment.paymentNumber)) {
              return accumulator;
            }
            return accumulator + payment.secondaryCurrencyTotalMonthlyPayment;
          }, 0);
        }, 0);
        this.amount = formatNumber({ number: total });
      } catch (error) {
        if (error.message === 'cancelled') return;
        this.isLoading = false;
        this.errorMessage = 'Ocurrió un error al tratar de calcular la deuda en la fecha seleccionada';
      }
    },
    isLoading(val) {
      this.$emit('is-loading', val);
    }
  },
  methods: {
    async updateTransaction() {
      this.isLoading = true;
      try {
        const updatedTransaction = await updateTransactionDebtDate(this.transaction._id, this.date.toISOString().substring(0, 10));
        this.$emit('updated-transaction', updatedTransaction);
      } catch (_error) {
        this.errorMessage = 'Ocurrió un error al tratar de modificar la transacción';
      }
      this.isLoading = false;
    }
  }
};
</script>
<style scoped>
.card {
  display: flex;
  flex-flow: column wrap;
  align-items: stretch;
  justify-content: flex-start;
  gap: 1rem;
  padding: 1.5rem;
}
#modifier-items {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  gap: 1rem;
}
#modifier-items div {
  display: flex;
  flex-flow: row wrap;
  align-items: center;
  justify-content: space-around;
  gap: 0rem 1rem;
}
  @media (max-width: 450px) {
  .card {
    padding: 3%;
  }
  #modifier-items {
    flex-flow: column wrap;
    align-items: center;
    justify-content: space-around;
    gap: 1rem;
  }
  }
</style>
